export enum VendorSmartPages {
  InvoiceDetails = 'invoice-details',
  InvoiceSearch = 'invoice-search',
}
